"use strict";
function setAspectRatio() {
    var outer = document.getElementById("video");
    var videoCover = document.getElementById("video-cover");
    var box = document.getElementById("muteYouTubeVideoPlayer");
    if (videoCover.clientHeight > window.innerWidth) {
        box.style.width = (outer.clientWidth * ((videoCover.clientHeight * 1.3) / outer.clientHeight)) + 'px';
        box.style.height = (videoCover.clientHeight * 1.3) + 'px';
    }
    else {
        box.style.height = (outer.clientHeight * ((window.innerWidth * 1.2) / outer.clientWidth)) + 'px';
        box.style.width = (window.innerWidth * 1.2) + 'px';
    }
}
window['onYouTubeIframeAPIReady'] = function onYouTubeIframeAPIReady() {
    var player;
    window.youtubeLoaded = true;
    if (window.innerWidth > 700) {
        var videoId = document.getElementById('videoId').getAttribute('value');
        var videoStartedInId_1 = parseInt(document.getElementById('videoStartedInId').getAttribute('value'), 10);
        player = new YT.Player('muteYouTubeVideoPlayer', {
            videoId: videoId,
            width: '100%',
            height: '100%',
            playerVars: {
                autoplay: 1,
                controls: 0,
                showinfo: 0,
                modestbranding: 1,
                loop: 0,
                fs: 0,
                cc_load_policy: 0,
                iv_load_policy: 0,
                autohide: 0,
                start: videoStartedInId_1,
                end: 440,
                disablekb: 1,
                onReady: 1,
                playlist: videoId
            },
            events: {
                onReady: function (e) {
                    e.target.mute();
                    e.target.setVolume(0);
                    e.target.setPlaybackQuality('highres');
                    setAspectRatio();
                    window.addEventListener('resize', function () {
                        setAspectRatio();
                    });
                },
                onStateChange: function (e) {
                    // Hack para funcionar tempo
                    if (videoStartedInId_1 > player.getCurrentTime() && videoStartedInId_1 != 0) {
                        document.getElementById('background-cover-video').style.display = "none";
                        document.getElementById('background-cover-video-mobile').style.display = "none";
                        player.seekTo(videoStartedInId_1);
                    }
                    if (e.data === YT.PlayerState.PLAYING) {
                        document.getElementById('background-cover-video').style.display = "none";
                        document.getElementById('background-cover-video-mobile').style.display = "none";
                        document.getElementsByClassName('video')[0].classList.add('started');
                    }
                    if (e.data === YT.PlayerState.ENDED) {
                        e.target.playVideo();
                        player.seekTo(videoStartedInId_1);
                        e.target.mute();
                        e.target.setVolume(0);
                        e.target.setPlaybackQuality('highres');
                    }
                }
            }
        });
    }
};
function startYoutube() {
    var tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}
startYoutube();
